import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@material-ui/core';
import { Typography } from 'kangarootime-ui';
import './ChildTable.css';
import PhotosTakenToday from './PhotosTakenToday';

const Row = ({ child, onRowSelect, selectPhoto }) => {
  return (
    <TableRow className='childRow' onClick={() => onRowSelect(child.child_id)}>
      <TableCell>
        <Typography>{child.first_name} {child.last_name}</Typography>
      </TableCell>
      <TableCell>
        <PhotosTakenToday photos={child.photosTakenToday} selectPhoto={selectPhoto} />
      </TableCell>
      <TableCell>
        <Typography>{child.numberOfPhotosTakenToday}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{child.child_photo_count}</Typography>
      </TableCell>
    </TableRow>
  );
};

Row.propTypes = {
  child: PropTypes.shape({
    child_id: ProcessingInstruction.number,
    child_photo_count: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    numberOfPhotosTakenToday: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
    photosTakenToday: PropTypes.array
  }),
  onSelect: PropTypes.func,
  selectPhotoPhoto: PropTypes.func
};

export default Row;
